module.exports = __webpack_public_path__ + "img/pills.cc35d36d.svg";